<template>
    <div class="ranklist">
        <div class="ranklist_my">
            <van-image round width="1.23rem" height="1.23rem" :src="userInfo.avatar"></van-image>
            <div class="ranklist_my_info">
                <div class="ranklist_my_info_new">
                    <div class="ranklist_my_info_name">{{userInfo.nickname}}</div>
                    <div class="ranklist_my_info_rank" v-if="userInfo.rank>0">排行第{{userInfo.rank}}名</div>
                </div>
                <!-- <div class="ranklist_my_info_id">
                    ID：wxid53988
                </div>  -->
            </div>
            <div class="ranklist_my_vote">
                <span>{{userInfo.score}}</span> 票
            </div>
        </div>
        <van-skeleton avatar :row="1" v-if="rankList.length==0"/>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
            <div v-for="(item,key) in front3" :key="key" class="item_ranklist">
                <div class="item_ranklist_info">
                    <van-image width="0.385rem" height="0.49rem" :src="require('@/assets/img/family/'+item.rank+'.png')"></van-image>
                    <div class="item_ranklist_person">
                        <van-image round width="0.71rem" height="0.71rem" :src="item.avatarurl"></van-image>
                        <div class="item_ranklist_name">{{item.name || item.nickname}}</div>
                    </div>
                </div>
                <div class="item_ranklist_rank">{{item.score+' 票'}}</div>
            </div>
            <div class="item_ranklist" v-for="(item,key) in rankList" :key="item.id" v-if="key>=3">
                <div class="item_ranklist_info">
                    <div class="rank">{{item.rank}}</div>
                    <div class="item_ranklist_person">
<!--                        <van-image round width="0.71rem" height="0.71rem" :src="item.avatarurl"></van-image>-->
                        <div class="item_ranklist_name">{{item.name || item.nickname}}</div>
                    </div>
                </div>
                <div class="item_ranklist_rank">{{item.score+' 票'}}</div>
            </div>
        </van-list>

    </div>
</template>
<script>
    import './index.less'
    import { Image, List } from 'vant';
    export default {
        name:"rankList",
        components:{
            vanList:List,
            vanImage:Image
        },
      props: ["itemid"],
        data() {
            return {
                mediaurl: '',
                imgurl:'',
                userInfo:{},
                familyList:[],
                rankList:[],
                front3:[],
                loading: false,
                finished: false,
                page:1
            }
        },
        methods: {
            goDetail:function (val) {
                // console.log(val)
                this.$emit('goDetail',val);
            },
            getFamilyList() {
                this.$api.sports.compareRank({page:this.page,cpgid: this.itemid,sort:2}).then((res)=>{
                    if(res.status*1===200){
                        this.front3 = []
                        this.rankList = this.rankList.concat(res.data.list)
                        res.data.myinfo.score = Math.floor(res.data.myinfo.score)
                        this.userInfo = res.data.myinfo
                        var t=null
                        this.rankList.forEach((item, index) => {
                            item.score = Math.floor(item.score)
                            if(t == null){
                                t =  item;
                                t.rank = index+1;
                            }else{
                                var n = item;
                                if(n.score*1 == t.score*1){
                                    n.rank = t.rank;
                                }else{
                                     n.rank = index+1;
                                }
                                t = n;
                            }
                            if (index < 3) {
                                this.front3.push(Object.assign({}, item));
                            }
                        })
                        if(res.data.pages*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }
                    }
                    this.loading = false;
                })
            },
            onLoad() {
                if(this.finished) return;
                this.getFamilyList();
            }
        },
        mounted(){
            this.$nextTick(()=>{
                // this.getFamilyList();
            })
        }
    }
</script>
